import React, { Component } from 'react';
import {connect} from 'react-redux';
import CategoryItem from './CategoryItem.jsx';
import {setDataBreadCrumb} from 'actions';

class AllCategoriesContainer extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      categories: this.props.categories,
      hasBreadcrumb: true
    };
  }

  componentDidMount() {
    let breadcrumb = [
      {name: 'Trang chủ', link: '/'},
      {name: 'Sản phẩm'}
    ]
    this.props.dispatch(setDataBreadCrumb(this.state.hasBreadcrumb, breadcrumb));
  }

  componentWillReceiveProps(nextProps) {
    const cateSort = nextProps.categories;
    let catSort = _.orderBy(cateSort, ['numberSort'], ['asc']);
    this.setState({
      categories: catSort,
    });
  }

  render() {
    return (
      <div className='category-S-left-list-wrapper'>
        <div className='category-S-left-list-row'>
        {
          this.state.categories.map((item, i) => {
            return (
              <CategoryItem key={i} {...item}/>
            )
          })
        }
        </div>
      </div>
    );
  }

}

let bindStateToProps = (state) => {
  return {
    categories: state.categoriesAsTree
  }
}

export default connect(bindStateToProps)(AllCategoriesContainer);



// WEBPACK FOOTER //
// ./components/all-categories/AllCategoriesContainer.jsx